import { render } from "./AnswerManagement.vue?vue&type=template&id=83a581b6&scoped=true"
import script from "./AnswerManagement.vue?vue&type=script&lang=js"
export * from "./AnswerManagement.vue?vue&type=script&lang=js"

import "./AnswerManagement.vue?vue&type=style&index=0&id=83a581b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a581b6"]])

export default __exports__